export type PersonDayErrorExplainRequest = {
    modelName: string;
    personId: string;
    date: Date;
    request: PersonDayErrorExplainRequestItem[];
};

export type PersonDayErrorExplainRequestItem = {
    type: PersonDayErrorExplainRequestItemType,
    content: string,
    citations: ExplainUpdateCitation[] | null;
    isError?: boolean;
};

export enum PersonDayErrorExplainRequestItemType {
    Input = 'Input',
    User = 'User',
    Assistant = 'Assistant'
};

export type ExplainUpdateCitation = {
    title: string,
    assumedReferenceName: string,
    content: string
};

export type ExplainUpdateType = { 
    type: 'Chunk' | 'Error' | 'End' | 'Cancel' | 'Citations', 
    content: string | null,
    citations?: ExplainUpdateCitation[]
};

export enum ExplainUpdateStatus {
    None,
    Loading,
    Cancel,
    Error,
    End
};

export enum AiRating {
    None,
    Like,
    Dislike
};